import {FORM_DIRECTIVES, REACTIVE_FORM_DIRECTIVES, FORM_PROVIDERS} from "@angular/forms";
import {AlertComponent, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {Component} from "@angular/core";
import {Dragula, DragulaService} from "ng2-dragula/ng2-dragula";
import {Router} from "@angular/router";
import {State} from "../../domain/state";
import {CitiesService} from "../../service/cities.service";
import {City} from "../../domain/city";

/**
 * .
 * Created by jlado on 23/1/17.
 */
@Component({
    selector: 'config-state',
    template: require('./config.state.component.html'),
    styles: [require('./config.state.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        Dragula
    ],
    providers: [FORM_PROVIDERS],
    viewProviders: [
        BS_VIEW_PROVIDERS,
        DragulaService
    ],
})
export class ConfigStateComponent {

    public states:State[];
    public cities:City[];

    public stateSelected:State;

    public successMessage:string;
    public error:any;

    public loading:boolean;
    private deleteMode:boolean;

    constructor(private router:Router,
                private citiesService:CitiesService,
                private dragulaService:DragulaService) {
        this.init();

        this.find();

        dragulaService.setOptions('states-bag', {
            direction: 'vertical',
            /*Elements in source cant be reordered*/
            copySortSource: false,
            moves: function(){
                return false;
            }
        });
    }

    private init():void {
        this.states = [];
        this.cities = [];

        this.loading = false;
        this.deleteMode = false;
    }

    public find():void {
        this.clearMessages();
        this.loading = true;
        this.citiesService.getStates().subscribe(
            (data) =>this.refreshData(data),
            () => {
                this.bindError('Ocurrió un error al buscar las provincias.');
            });
    }

    public showCities(state:State):void {
        this.stateSelected = state;
        if (this.stateSelected != null) {
            this.citiesService.getCities(this.stateSelected.id).subscribe(
                (data) =>this.cities = data,
                () => {
                    this.bindError('Ocurrió un error al buscar las localidades.');
                });
        }
    }

    private refreshData(states:State[]):void {
        this.states = states;
        this.loading = false;
    }

    public removeState(deleteModal:any):void {
        this.clearMessages();
        this.citiesService.deleteState(this.stateSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeStateFromView(this.stateSelected);
                this.deleteMode = true;
            },
            () => {
                this.bindError('Ocurrió un error al eliminar la provincia.');
            });
    }

    private removeStateFromView(state:State):void {
        let index = this.states.indexOf(state);
        if (index > -1) {
            this.states.splice(index, 1);
        }
        this.stateSelected = null;
    }

    public createState():void {
        this.router.navigate(['app/home/config/createState']);
    }

    public editState(state:State):void {
        this.router.navigate(['app/home/config/editState', state.id]);
    }

    private clearMessages():void {
        this.successMessage = null;
        this.error = null;
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/states/config.state.component.ts
 **/